var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1D41FF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3151 6.43689C11.0218 6.72816 10.8752 7.08252 10.8752 7.5C10.8752 7.91748 11.0218 8.27184 11.3151 8.56311C11.6084 8.85437 11.9617 9 12.3752 9C12.7887 9 13.142 8.85437 13.4353 8.56311C13.7286 8.27184 13.8752 7.91748 13.8752 7.5C13.8752 7.08252 13.7286 6.72816 13.4353 6.43689C13.142 6.14563 12.7887 6 12.3752 6C11.9617 6 11.6084 6.14563 11.3151 6.43689Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.885H15.75V17.385H9V15.885H11.25V11.385H9.04521V9.88504H13.5V15.885Z",
    fill: "black",
    fillOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipGrey);
export default __webpack_public_path__ + "static/media/tooltip-grey.648e295de2dad3648e2d7ea1350f3b37.svg";
export { ForwardRef as ReactComponent };